(function ($) {
    'use strict';

    $(document).ready(function () {
        // Handle all Contact Forms (Home, Contact Page, Tour Request)
        $(document).on('submit', '#home-contact-form, #contact-page-form, #tour-request-form', function (e) {
            e.preventDefault();

            const $form = $(this);
            const $submitBtn = $form.find('button[type="submit"]');
            const $response = $form.find('.form-response');
            const originalBtnText = $submitBtn.text();

            // Clear previous response
            $response.hide().removeClass('alert alert-success alert-danger').text('');

            // Basic validation for required fields
            let hasError = false;
            $form.find('[required]').each(function () {
                if (!$(this).val()) {
                    hasError = true;
                    $(this).addClass('is-invalid');
                } else {
                    $(this).removeClass('is-invalid');
                }
            });

            if (hasError) {
                $response.addClass('alert alert-danger').text('Please fill in all required fields.').show();
                return;
            }

            // UI Feedback: Loading
            $submitBtn.prop('disabled', true).text('Sending...');

            // Prepare data - use serialize to catch all fields including form_type etc.
            const formData = $form.serialize();

            // AJAX Request
            $.ajax({
                url: reim_ajax.ajaxurl,
                type: 'POST',
                data: formData,
                success: function (res) {
                    if (res.success) {
                        $response.addClass('alert alert-success').text(res.data.message).show();
                        $form[0].reset();
                    } else {
                        $response.addClass('alert alert-danger').text(res.data.message || 'An error occurred. Please try again.').show();
                    }
                },
                error: function () {
                    $response.addClass('alert alert-danger').text('Server error. Please try again later.').show();
                },
                complete: function () {
                    $submitBtn.prop('disabled', false).text(originalBtnText);
                }
            });
        });
    });
})(jQuery);
